import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs/internal/Observable';
import { AddTaskEndpoints } from '../../config/add-Task/add-Task-end-points';

@Injectable({
  providedIn: 'root'
})
export class AddTaskService {


  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }

  addUpdateTask<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.AddUpdateTask, model);
   }

   getTask<T>(reqModel:any): Observable<any>{   
    console.log("reqModel isExactIRNMatch",reqModel.isExactIRNMatch); 
    return this.genericApiService.post(AddTaskEndpoints.GetTasks, reqModel);
   } 

   getTaskById<T>(reqModel:any): Observable<any>{  
    return this.genericApiService.post(AddTaskEndpoints.GetTasksById, reqModel);
   }

   GetTotalTasksById<T>(reqModel:any): Observable<any>{  
    return this.genericApiService.post(AddTaskEndpoints.GetTotalTasksById, reqModel);
   }

   addUpdateSubTask<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.AddUpdateSubTask, model);
   }

   subTaskIRN<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.SubTaskIRN, model);
   }
    

   deleteTask<T>(TaskId: number,SiteId:number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${AddTaskEndpoints.DeleteTask}/${TaskId}/${SiteId}`);
   }

   deleteSubTask<T>(SubTaskId: number,SiteId:number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${AddTaskEndpoints.DeleteSubTask}/${SubTaskId}/${SiteId}`);
   }

   getSubTasksById<T>(reqModel:any): Observable<any>{  
    return this.genericApiService.post(AddTaskEndpoints.GetSubTasksById, reqModel);
   }

   searchTasks<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(AddTaskEndpoints.SearchTasks, reqModel);
   }
   
   getPoIRNNo<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.GetLastPONumberbyTaskSubTask, model);
   }

   getWoIRNNo<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.GetLastWONumberbyTaskSubTask, model);
   }

   sendMailTaskSubTask<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.sendMail, model);
   }
 
   addUpdatePurchaseOrderDetails<T>(model: any): Observable<HttpResponse<T>> {   
    return this.genericApiService.post(AddTaskEndpoints.addUpdatePurchaseOrders, model);
   }

   addUpdateWorkOrderDetails<T>(model: any): Observable<HttpResponse<T>> {    
     return this.genericApiService.post(AddTaskEndpoints.addUpdateWorkOrders, model);
    }

   getTaskExport<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(AddTaskEndpoints.GetTasksForExport, reqModel);
   } 

   getLevelAllmultiple<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(AddTaskEndpoints.GetLevelAllmultiple, reqModel);
   } 

   getAllTenancyOnSiteLevel<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(AddTaskEndpoints.GetAllTenancyOnSiteLevel, reqModel);
   } 

   addUpdateUserSiteConnection<T>(reqModel:any): Observable<unknown>{        
    return this.genericApiService.post<T>(AddTaskEndpoints.addUpdateUserSiteConnection, reqModel);
   }
  
   deleteTaskAction<T>(reqModel: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post<T>(AddTaskEndpoints.DeleteTaskAction, reqModel);
   }
   
   updateTaskSubTaskActionTaken<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.updateTaskSubTaskActionTaken, model);
   }

   gettaskDescription<T>(reqModel:any): Observable<any>{        
    return this.genericApiService.post(AddTaskEndpoints.gettaskDescription, reqModel);
   } 

   getTaskDescriptionExport<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(AddTaskEndpoints.getTaskDescriptionExport, reqModel);
   } 

   AddActionTakenTask<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.AddActionTakenTask, model);
   }

   AddActionTakenSubTask<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.AddActionTakenSubTask, model);
   }

   addUpdatePOAttachment<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.addUpdatePOAttachment, model);
   }

   confidentialTaskSubTask<T>(model: any): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AddTaskEndpoints.confidentialTaskSubTask, model);
   }
   UpdateEmbdocumentDetails<T>(model: any): Observable<any> {
    return this.genericApiService.post(AddTaskEndpoints.UpdateEmbdocumentDetails, model);
   }
   GetUplodedFileForTask<T>(model: any): Observable<any>{
    return this.genericApiService.post(AddTaskEndpoints.GetUplodedFileForTask, model);
   }
   UpdateFileNameForEmbd<T>(model: any): Observable<any>{
    return this.genericApiService.post(AddTaskEndpoints.UpdateTaskFileNameEmbd, model);
   }
   DownloadFile<T>(model: any): Observable<any>{
    return this.genericApiService.post(AddTaskEndpoints.DownloadFile, model);
   }
   DeleteEmbdFile<T>(model: any): Observable<any>{
    return this.genericApiService.post(AddTaskEndpoints.DeleteEmbdFile, model);
   }
   
   getTaskDescById<T>(reqModel:any): Observable<any>{  
    return this.genericApiService.post(AddTaskEndpoints.GetTaskDescById, reqModel);
   }

  //  checkTaskAccess(taskId: number): Observable<any> {
  //   return this.genericApiService.get(`${AddTaskEndpoints.CheckTaskAccess}?taskId=${taskId}`);
  // }

  checkSiteAccess(siteId: number) {
    return this.genericApiService.get(
      `${AddTaskEndpoints.CheckTaskAccess}?siteId=${siteId}`
    );
  }

  refineTask(model: any): Observable<any> {
    return this.genericApiService.post(AddTaskEndpoints.Refine, model);
  }

  checkDuplicates(model: any): Observable<any> {
    return this.genericApiService.post(AddTaskEndpoints.CheckDuplicates, model);
  }
}
